import AreaHub from 'components/area-hub/area-hub';
import Area from 'components/area-hub/area';
import Case from 'components/area-hub/case';

const gamePagesData = {
	areaHub: {
		component: AreaHub,
		background: 'office',
		infoTitle: '!VIGTIG BESKED!',
		infoText: `Velkommen til <b>HTX</b> og jeres <b>studiejob hos Nordic BioLab</b>.
			<br /><br />Nu skal I udforske, hvordan <b>HTX</b> hænger sammen med de opgaver, man kan arbejde med bagefter.
			<br /><br /><b>Nordic BioLab</b> udvikler kosttilskud og medicin i moderne laboratorier.
			<br /><br />Jeres opgave er at tage de <b>bedste beslutninger for virksomheden</b> - og for jeres hold. I konkurrerer mod de andre hold og vinder ved at <b>svare rigtigt og undgå fejl</b>.
			<br /><br />I skal besøge HTX-uddannelsen og virksomhedens forskellige områder og afdelinger, hvor I løser udfordringer og træffer beslutninger. 
			<br />Nogle opgaver kræver viden - <b>andre kræver, at I tænker jer frem</b>.
			<br /><br />I kan starte, <b>hvor I vil</b>. Hvert område indeholder udfordringer, som giver point, når I løser dem.
			<br /><br />Hvis I vil vinde, handler det ikke om at svare hurtigt - men om at svare rigtigt.
			<br />Der er et <b>begrænset antal udfordringer</b>, så tænk jer om: <b>Jo færre fejl, I laver, jo flere point får I</b>.
			<br /><br />Klik rundt, løs opgaverne, indtil tiden løber ud - og se, om I kan slå de andre hold.
			<br /><br /><b>Held og lykke - og husk, at I kan følge stillingen på pointtavlen!</b>`,
		routes: [
			{
				id: 'build',
				name: 'byggeri & miljø',
				pageId: 'areaBuild'
			},
			{
				id: 'safety',
				name: 'sikkerhed & sundhed',
				pageId: 'areaSafety'
			},
			{
				id: 'it',
				name: 'it & kommunikation',
				pageId: 'areaIt'
			},
			{
				id: 'research',
				name: 'teknologi & forskning',
				pageId: 'areaResearch'
			},
			{
				id: 'education',
				name: 'uddannelsen & fremtiden',
				pageId: 'areaEducation'
			}
		]
	},
	areaBuild: {
		component: Area,
		caseComponent: Case,
		id: 'build',
		background: 'build',
		infoTitle: 'Byggeri & Miljø',
		infoText: `Dette er virksomhedens bygge- og miljø afdeling. De står for udvikling og vedligeholdelse af bygninger.`,
		routes: [
			{
				id: 1,
				title: 'Udfordring 1',
				subtitle: 'Ny tank',
				pageId: null,
				text: 'I Byggeri & Miljø-afdelingen står I over for jeres første opgave. Der skal placeres en ny tank i produktionshallen. Den skal have tre gange så stor kapacitet, og det giver nogle udfordringer.'
			},
			{
				id: 2,
				title: 'Udfordring 2',
				subtitle: 'Vedligeholdelse',
				pageId: null,
				text: 'Byggeafdelingen står også for at vedligeholde bygninger og udstyr.'
			},
			{
				id: 3,
				title: 'Udfordring 3',
				subtitle: 'Miljø',
				pageId: null,
				text: 'Bæredygtighed og miljø er meget vigtige for Nordic BioLab. I dette område skal I arbejde med, hvordan virksomheden kan tage hensyn til miljøet i praksis.'
			}
		]
	},
	areaSafety: {
		component: Area,
		caseComponent: Case,
		id: 'safety',
		background: 'safety',
		infoTitle: 'Sikkerhed & Sundhed',
		infoText: `Virksomheden har både et beredskabskorps samt en masse sikkerhedsinstrukser, som træder i kraft i nødstilfælde.`,
		routes: [
			{
				id: 1,
				title: 'Udfordring 1',
				subtitle: 'Sikkerhed',
				pageId: null,
				text: 'Hos Nordic BioLab arbejder man med både maskiner, kemi og teknik. Derfor er sikkerhed ekstremt vigtigt. Den første udfordring handler om grundlæggende sikkerhed.'
			},
			{
				id: 2,
				title: 'Udfordring 2',
				subtitle: 'Sundhed',
				pageId: null,
				text: 'For at udvikle nye produkter er det vigtigt vi kender menneskekroppen, I skal nu finde nogle svar omkring menneskets sundhed.'
			}
		] 
	},
	areaIt: {
		component: Area,
		caseComponent: Case,
		id: 'it',
		background: 'it',
		infoTitle: 'IT & Kommunikation',
		infoText: `IT og kommunikation spiller en vigtig rolle hos Nordic BioLab. I dette område skal I arbejde med data, systemer og kommunikation i virksomheden.`,
		routes: [
			{
				id: 1,
				title: 'Udfordring 1',
				subtitle: 'IT',
				pageId: null,
				text: 'IT-afdelingen arbejder blandet andet med kodning til eksisterende systemer. Derfor handler første case om grundlæggende programmering og arbejdsmetoder. '
			},
			{
				id: 2,
				title: 'Udfordring 2',
				subtitle: 'Kommunikation og reklame',
				pageId: null,
				text: 'Nordic BioLab har også en markedsføringsafdeling. Virksomheden sælger både til offentlige institutioner og privatpersoner, hvilket giver nogle udfordringer.'
			},
			{
				id: 3,
				title: 'Udfordring 3',
				subtitle: 'Ny indpakning',
				pageId: null,
				text: 'Der skal laves et nyt design til en indpakning.'
			},
			{
				id: 4,
				title: 'Udfordring 4',
				subtitle: 'Regler og oplysning',
				pageId: null,
				text: 'Nordic BioLab har et produkt, som fungerer som et receptpligtigt lægemiddel. Det skal ud på markedet og sælges, men det er vigtigt, at Nordic BioLab overholder de gældende regler på området.'
			}
		]
	},
	areaResearch: {
		component: Area,
		caseComponent: Case,
		id: 'research',
		background: 'research',
		infoTitle: 'Teknologi & Forskning',
		infoText: `Virksomheden producerer enzymer i et moderne laboratorium og forsker samtidig i at udvikle og forbedre produkterne.`,
		routes: [
			{
				id: 1,
				title: 'Udfordring 1',
				subtitle: 'Klargøring',
				pageId: null,
				text: `I Teknologi og Forskning arbejder Nordic BioLab med kemi, test og udvikling, hvor præcision og forberedelse er afgørende.`,
			},
			{
				id: 2,
				title: 'Udfordring 2',
				subtitle: 'Enzymproduktion',
				pageId: null,
				text: 'Produktion af medicin med enzymer kræver, at mange faktorer går op i en højere enhed. Og der skal konstant måles og justeres, så alting fungerer optimalt.'
			},
			{
				id: 3,
				title: 'Udfordring 3',
				subtitle: 'Valg af robotter',
				pageId: null,
				text: `Et af de vigtigste spørgsmål er, hvor I skal satse på robotteknologi. Nogle områder egner sig bedre til det end andre.`
			},
			{
				id: 4,
				title: 'Udfordring 4',
				subtitle: 'Robotter',
				pageId: null,
				text: `Nordic BioLab ønsker at benytte robotteknologi i fremtiden. Ledelsen skal dog have forståelse for den nye måde at tænke produktionsprocessen på.`
			},
			{
				id: 5,
				title: 'Udfordring 5',
				subtitle: 'Uheld',
				pageId: null,
				text: `Afdelingen er ved at undersøge en række enzymer, som blev opbevaret i forskellige plastbeholdere. Det viser sig, at der er hul i en af beholderne, og det kræver hurtig handling fra jeres side.`
			},
			{
				id: 6,
				title: 'Udfordring 6',
				subtitle: 'Enzym X',
				pageId: null,
				text: `Det viser sig, at det nye enzym – med kodenavnet Enzym X – kan nedbryde plastik. Det giver nye muligheder og kan blive et stort gennembrud for Nordic BioLabs produktudvikling.`
			},
			{
				id: 7,
				title: 'Udfordring 7',
				subtitle: 'Ny udvikling',
				pageId: null,
				text: `R&D-afdelingen udvikler hele tiden nye produkter eller varianter af de eksisterende. Målet er altid at få nye lægemidler på markedet, men det er en lang og tung proces.`
			}
		] 
	},
	areaEducation: {
		component: Area,
		caseComponent: Case,
		id: 'education',
		background: 'education',
		infoTitle: 'Uddannelsen & Fremtiden',
		infoText: `Her får I indblik i uddannelsens fag, studieretninger og hverdag – samt hvilke muligheder den kan føre til bagefter.`,
		routes: [
			{
				id: 1,
				title: 'Udfordring 1',
				subtitle: 'Om HTX',
				pageId: null,
				text: `Her tager vi de første skridt ind i HTX-verdenen. Prøv opgaver, der giver jer et hurtigt og enkelt indblik i, hvad HTX handler om.`,
			},
			{
				id: 2,
				title: 'Udfordring 2',
				subtitle: 'Uddannelsen',
				pageId: null,
				text: 'Tid til at dykke ned i, hvordan det er at gå på HTX. Her får I et hurtigt indblik i, hvordan uddannelsen er bygget op, og hvad det egentlig vil sige at være en del af den.'
			},
			{
				id: 3,
				title: 'Udfordring 3',
				subtitle: 'Fremtiden',
				pageId: null,
				text: 'Nu ser vi på, hvad der kan ske efter gymnasiet. Der er masser af muligheder – og masser af point at hente.'
			},
			{
				id: 4,
				title: 'Udfordring 4',
				subtitle: 'Studieretninger og fag',
				pageId: null,
				text: 'Her skal I tjekke spændende fakta om studieretninger og fag – og få styr på det vigtigste.'
			},
			{
				id: 5,
				title: 'Udfordring 5',
				subtitle: 'Obligatoriske fag',
				pageId: null,
				text: 'Velkommen til fagverdenen på %school%! Her bliver I udfordret på, hvilke fag der er vigtige, hvordan niveauerne fungerer, og hvilke fag I selv kan vælge.'
			}
		] 
	}
};

export {
	gamePagesData,
};